import { useAzureAuthScreenRedirect } from '@order/AzureAuth';

// ────────────────────────────────────────────────────────────────────────────────

export const JoinScreen = () => {
  useAzureAuthScreenRedirect();

  return null;
};
